import React from 'react';
import { Nav } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SimpleBar from 'simplebar-react';
import NavItemContainer from './NavItemContainer';
import NavSubMenu from './NavSubMenu';
import user1 from '../../../assets/images/users/user4.jpg';
import probg from '../../../assets/images/bg/background_inconnect.png';
import MaterialIcon from '@material/react-material-icon';
import IconoFace from '../../../assets/images/icons/face.png'
const Sidebar = ({ menuData, userPhoto }) => {
  // Recibe menuData como prop
  const location = useLocation();
  const currentURL = location.pathname.split('/').slice(0, -1).join('/');
  const activeBg = useSelector((state) => state.customizer.sidebarBg);
  const isFixed = useSelector((state) => state.customizer.isSidebarFixed);
  //console.log(menuData);

  return (
    /***********Cabecera de la Sidebar*********** */

    <div className={`sidebarBox shadow bg-${activeBg} ${isFixed ? 'fixedSidebar' : ''}`}>
      <SimpleBar style={{ height: '100%' }}>
        {/* <div className="profilebg" style={{ background: `url(${probg}) no-repeat` }}>
          <div className="p-3 d-flex">
            {userPhoto ? (
              <img
                src={userPhoto}
                alt="user" width="50" className="rounded-circle"
              />
            ) : (
              <img
                src="/ruta/a/imagen-default.png"
                alt="user" width="50" className="rounded-circle"
              />
            )}
          </div>
          <div className="p-4"></div>
        </div> */}
        {/* /******Contenido de la Sidebar**** */ }
        <div className="p-3 pt-1 mt-2">
          <Nav vertical className={activeBg === 'white' ? '' : 'lightText'}>
            {menuData.map((navi) =>
              navi.caption ? (
                <div className="navCaption text-uppercase mt-4" key={navi.caption}>
                  {navi.caption}
                </div>
              ) : navi.children && navi.children.length > 0 ? (
                <NavSubMenu
                  key={navi.id}
                  icon={<MaterialIcon icon={navi.icon.props.icon} />} // Aquí debería estar el icono
                  title={navi.title}
                  items={navi.children.map((child) => ({
                    ...child, // Spread para pasar todas las propiedades del hijo
                    icon: <MaterialIcon icon={child.icon.props.icon} />, // Icono de cada hijo
                  }))}
                  suffix={navi.suffix}
                  suffixColor={navi.suffixColor}
                  isUrl={currentURL === navi.href}
                />
              ) : (
                <NavItemContainer
                  key={navi.id}
                  className={location.pathname === navi.href ? 'activeLink' : ''}
                  to={navi.href}
                  title={navi.title}
                  suffix={navi.suffix}
                  suffixColor={navi.suffixColor}
                  icon={<MaterialIcon icon={navi.icon.props.icon} />} // Aquí también
                />
              ),
            )}
          </Nav>
        </div>

      </SimpleBar>
    </div>
  );
};

export default Sidebar;
